import axios from 'axios';
import Vue from 'vue';
import  { autoLogOutTimeSet } from '@common/helpers/auto-logout';
import isMobileDevice from './utils/device';

const hostname = window.location.host;
const isDevelopment = hostname.startsWith('localhost') || hostname.startsWith('127.0.0.1:8080');
const baseURL = isDevelopment ? 'http://localhost:3022/tms-optima/api' : '/tms-optima/api';

const tmsOptimaAxiosInstance = axios.create({ baseURL, timeout: 1800000 });

tmsOptimaAxiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('tsm-user-token');
  const isLogin = window.location.pathname === '/login';
  if ((token && token !== 'undefined')) { //  && !isLogin) {
    config.headers = { Authorization: `bearer ${token}` }; // eslint-disable-line
  }
  config.headers['X-Device-Type'] = isMobileDevice() ? 'mobile' : 'desktop';
  return config;
}, error => Promise.reject(error));

tmsOptimaAxiosInstance.interceptors.response.use((response) => {
  const token = response.headers['x-auth-token'];
  autoLogOutTimeSet(response.status);
  if (token) {
    localStorage.setItem('tsm-user-token', token);
  }
  return (response.data) ? response.data : response;
}, error => Promise.reject(error.response));

Vue.prototype.$tmsOptimaAxios = tmsOptimaAxiosInstance;

export default tmsOptimaAxiosInstance;
